<ion-app>
  <div
    class="app-boot"
    *ngIf="(booting$ | async) && !isPublicRoute"
    role="status"
    aria-label="Loading">
    <img src="./assets/logos/cri-hub-logo-color.png" alt="CRI HUB" />
    <div class="app-boot-spinner"></div>
  </div>
  <div
    class="test-line top"
    *ngIf="currentUser && currentUser.isTestTenant"></div>

  <div class="app-content" [class.blurred]="showLockScreen">
    <ng-container *ngIf="(userService.user$ | async) && !isPublicRoute">
      <div class="layout">
        <ion-split-pane when="md" contentId="main-content" mode="md">
          <ion-menu
            contentId="main-content"
            [class.mini-sidebar]="!canShowSidebar">
            <div class="side-panel">
              <app-side-menu></app-side-menu>
            </div>
          </ion-menu>
          <div class="content" id="main-content">
            <div id="import-classes-alert"></div>
            <div class="page-header">
              <page-header></page-header>
            </div>
            <div class="router">
              <ion-router-outlet
                (stackDidChange)="firstPage$.next()"></ion-router-outlet>
            </div>
          </div>
        </ion-split-pane>
        <!-- Ionic loads a component's code the first time it is connected and
             keeps it invisible until then; the first list page to use these
             would otherwise show empty rows for as long as that takes. -->
        <div hidden aria-hidden="true" class="ionic-warm-up">
          <ion-checkbox></ion-checkbox>
          <ion-skeleton-text></ion-skeleton-text>
          <ion-searchbar></ion-searchbar>
          <ion-list><ion-item></ion-item></ion-list>
          <ion-spinner></ion-spinner>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!(userService.user$ | async) || isPublicRoute">
      <ion-router-outlet
        (stackDidChange)="firstPage$.next()"></ion-router-outlet>
    </ng-container>
  </div>

  <div
    class="test-line bottom"
    *ngIf="currentUser && currentUser.isTestTenant"></div>

  <!-- Lock Screen Overlay -->
  <div *ngIf="showLockScreen" class="lock-screen">
    <div class="lock-content">
      <ion-icon
        name="finger-print-outline"
        (click)="initializeBioAuth()"
        class="lock-icon"></ion-icon>
      <p>Tap the fingerprint icon to authenticate</p>
      <p *ngIf="authError" class="error">{{ authError }}</p>
    </div>
  </div>
</ion-app>
